interface CustomReferenceLabelProps {
  viewBox?: {
    x: number;
    y: number;
  };
  value: number;
}
export const CustomReferenceLabel = ({
  viewBox,
  value
}: CustomReferenceLabelProps) => {
  if (!viewBox || typeof viewBox.x !== "number") return null;
  return <g data-sentry-element="g" data-sentry-component="CustomReferenceLabel" data-sentry-source-file="CustomReferenceLabel.tsx">
      <rect x={viewBox.x - 24} y={viewBox.y + 10} width={48} height={20} className="fill-surface" rx={4} fillOpacity={0.9} data-sentry-element="rect" data-sentry-source-file="CustomReferenceLabel.tsx" />
      <text x={viewBox.x} y={viewBox.y + 22} textAnchor="middle" dominantBaseline="middle" fontSize="14" fontWeight="600" className="fill-gray-900" data-sentry-element="text" data-sentry-source-file="CustomReferenceLabel.tsx">
        {value}
      </text>
    </g>;
};